import * as style from './style.module.css';

const ResponsiveBreakLine = () => {
    return <div className={style.brk} />
}

export default ResponsiveBreakLine;
